import z from 'zod'
import { FirstSourceEventDTOScheme } from './firstSourceEventDTO'

export const FirstSourceResponceDTOScheme = z.object({
	count: z.number().nullable().optional(),
	from: z.string().nullable().optional(),
	to: z.string().nullable().optional(),
	total: z.string().nullable().optional(),
	items: FirstSourceEventDTOScheme.array().nullable().optional()
})

export type FirstSourceResponceDTO = z.output<typeof FirstSourceResponceDTOScheme>
